import { store } from '@betacrew/jars-flux'
import { ALL_SELECTED } from '../constants';
import DateUtils from '../../../../libs/utility/DateUtils';
export const componentKey = "REPORTS_PAYERS";

const { actions } = store.reducerManager.add({
	key: componentKey,
	addedReducers: {
		setHeaders: (state, action) => {
			state.headers = action.payload;
		},
		setXlsx: (state, action) => {
			state.isXlsx = action.payload;
		},
		setFromDate: (state, action) => {
			state.fromDate = action.payload;
		},
		setToDate: (state, action) => {
			state.toDate = action.payload;
		},
		setExportFile: (state, action) => {
			state.exportFile = action.payload;
		},
		setLoadingState: (state, action) => {
			state.loadingState = action.payload
		},
		setDropDownOptions: (state, action) => {
			state.dropDownOptions = action.payload
		},
		setMultiSelectdropDownOptions: (state, action) => {
			state.multiSelectdropDownOptions = action.payload;
		},
		setSelectedMultiSelectdropDownOptions: (state, action) => {
			state.selectedMultiSelectdropDownOptions = [...state.selectedMultiSelectdropDownOptions, action.payload]
		},
		setSelectedDropDownOption: (state, action) => {
			state.selectedDropDownOption = action.payload
		},
		setFilterText: (state, action) => {
			state.filterText = action.payload
		},
		setSecondaryDropDownOptions: (state, action) => {
			state.secondaryDropDownOptions = action.payload
		},
		setSelectedSecondaryDropDownOptions: (state, action) => {
			state.selectedSecondaryDropDownOptions = action.payload
		},
		setSkip: (state, action) => {
			state.skip = action.payload
		},
		setRowsPerPage: (state, action) => {
			state.rowsPerPage = action.payload
		},
		setGridData: (state, action) => {
			state.gridData = action.payload
		},
		setGridTotal: (state, action) => {
			state.gridTotal = action.payload
		},
		setUSPSAmount: (state, action) => {
			state.uspsAmount = action.payload
		},
		setPayerDropdownPagination: (state, action) => {
			state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
		},
		setPayrollStateList: (state, action) => {
			state.stateList = action.payload;
		},
		setPayrollSelectedState: (state, action) => {
			state.selectedState = action.payload;
		},
		setFormList: (state, action) => {
			state.formList = action.payload;
		},
		setSelectedForm: (state, action) => {
			state.selectedForm = action.payload;
		},
	},
	initialReducerState: {
		headers: null,
		filterText: '',
		dropDownOptions: [],
		secondaryDropDownOptions: null,
		selectedSecondaryDropDownOptions: null,
		selectedDropDownOption: { label: ALL_SELECTED, value: ALL_SELECTED },
		multiSelectdropDownOptions: [],
		selectedMultiSelectdropDownOptions: [],
		isXlsx: false,
		fromDate: DateUtils.dateFormatter(DateUtils.dateSubtractor(7, 'd'), "YYYY-MM-DD"),
		toDate: DateUtils.dateFormatter(new Date(), "YYYY-MM-DD"),
		exportFile: {},
		loadingState: false,
		gridData: [],
		rowsPerPage: 10,
		skip: 0,
		gridTotal: 0,
		uspsAmount: 0,
		payerDropdownPagination: {
			PageNumber: 1,
			PageSize: 10,
		},
		stateList: [{ label: 'Select State', value: 0 }],
		selectedState: [{ label: 'Select State', value: 0 }],
		formList: [{ label: 'Select Form', value: 0 }],
		selectedForm: [{ label: 'Select Form', value: 0 }],
	}
});
export const { setGridTotal,
	setGridData,
	setRowsPerPage,
	setSkip,
	setSecondaryDropDownOptions,
	setSelectedSecondaryDropDownOptions,
	setSelectedMultiSelectdropDownOptions,
	setMultiSelectdropDownOptions,
	setFilterText,
	setSelectedDropDownOption,
	setDropDownOptions,
	setHeaders,
	setXlsx,
	setFromDate,
	setToDate,
	setExportFile,
	setLoadingState,
	setUSPSAmount,
	setPayerDropdownPagination,
	setFormList,
	setSelectedForm,
	setPayrollStateList,
	setPayrollSelectedState,
} = actions;